import React, { type ComponentProps, useCallback, useState } from 'react';

import { fg } from '@confluence/feature-gating';
import { RovoBridgeCommandListener } from '@confluence/rovo-editor-bridge-listener/entry-points/RovoBridgeCommandListener.ts';

import { useOpenSelectedAgentOnEditPageReady } from './hooks/useOpenSelectedAgentOnEditPageReady.ts';

type RovoBridgeCommandListenerWithAutoOpenProps = Omit<
	ComponentProps<typeof RovoBridgeCommandListener>,
	'onBridgeReady'
> & {
	isLivePage: boolean;
	isLivePageReady: boolean;
};

const SelectedAgentHandoff = ({
	contentId,
	isLivePage,
	isLivePageReady,
	isRovoBridgeReady,
}: {
	contentId: string;
	isLivePage: boolean;
	isLivePageReady: boolean;
	isRovoBridgeReady: boolean;
}) => {
	useOpenSelectedAgentOnEditPageReady({
		contentId,
		isLivePage,
		isLivePageReady,
		isRovoBridgeReady,
	});

	return null;
};

export const RovoBridgeCommandListenerWithAutoOpen = ({
	contentId,
	isLivePage,
	isLivePageReady,
	...listenerProps
}: RovoBridgeCommandListenerWithAutoOpenProps): React.JSX.Element => {
	const [rovoBridgeReadyContentId, setRovoBridgeReadyContentId] = useState<string>();
	const handleRovoBridgeReady = useCallback(() => {
		// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
		if (fg('post-office_enable_cc-agents-awareness-modal')) {
			setRovoBridgeReadyContentId(contentId);
		}
	}, [contentId]);

	return (
		<>
			<RovoBridgeCommandListener
				{...listenerProps}
				contentId={contentId}
				onBridgeReady={handleRovoBridgeReady}
			/>
			{/* eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred. */}
			{fg('post-office_enable_cc-agents-awareness-modal') && (
				<SelectedAgentHandoff
					contentId={contentId}
					isLivePage={isLivePage}
					isLivePageReady={isLivePage && isLivePageReady}
					isRovoBridgeReady={rovoBridgeReadyContentId === contentId}
				/>
			)}
		</>
	);
};
